const firebaseConfig = {
  apiKey: "AIzaSyCOwFZrYxUlXT2V8i0sFjcG7TG7h1YwyeQ",
  authDomain: "aftershoot-co.firebaseapp.com",
  databaseURL: "https://aftershoot-co.firebaseio.com",
  projectId: "aftershoot-co",
  storageBucket: "aftershoot-co.appspot.com",
  messagingSenderId: "953041219166",
  appId: "1:953041219166:web:f6ca9c9990e346e4ddcecf",
  measurementId: "G-Y8MX0HJE7W",
};

export default firebaseConfig;
